import { WESUB_ORDER_API_PATH } from "./constants";

export async function createWesubOrder(
  items: WesubOrderItem[],
  userData: WesubClientData,
  isB2C: boolean = false,
): Promise<{ redirectUrl: string; rentUPOrderId: string }> {
  const response = await fetch(WESUB_ORDER_API_PATH, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items,
      client: userData,
      b2c: isB2C,
    }),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(body?.error ?? "Nie udało się utworzyć zamówienia.");
  }

  return response.json() as Promise<{
    redirectUrl: string;
    rentUPOrderId: string;
  }>;
}
